import React, { Component } from "react";
import { Regular } from "@worthy-npm/clarity";
import PageHeader from "./pageHeader";
import PageIntro from "./pageIntro";
import LikeDislikeBanner from "./likeDislikeBanner";
import ServicesSection from "./servicesSection";
import DIYSection from "./DIYSection";
import ProsConsBox from "./prosConsBox";
import { isMobile, imageUrl } from "helpers/ApplicationHelper";
import { connect } from "react-redux";
const EVENTS_LABEL = "from Where To Sell page";

class WhereToSell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openComingSoon: false,
    };

    this.isMobile = isMobile();
  }

  comparisonData() {
    return [
      {
        title: "Local jewelers",
        images: [],
        pros: [
          "Sell almost instantly",
          "Normally safe and trustworthy",
          "Likely to get an offer",
        ],
        cons: [
          "Requires legwork",
          "Likely to give low offers",
          "Only one potential buyer - no competition",
          "Jeweler may prefer to consign or trade-in",
        ],
        bottomLine:
          "In the event that you do find a jeweler who will buy your item, the offer will likely be low.",
      },
      {
        title: "Managed online marketplaces",
        images: ["experts/logos/worthy.png"],
        pros: [
          "Easy - all you need to do is ship",
          "Mid-high value offers",
          "You can set your own price",
          "High likelihood of selling",
          "Managed process eliminates exposure to scammers",
          "Exposure to large buyer pool creates competition",
        ],
        cons: ["May take 7-14 days from shipping to payment"],
        bottomLine:
          "This is an easy option and your chances of selling for a good price are high.",
      },
      {
        title: "Online marketplaces",
        images: [
          "experts/logos/facebookMarketplace.png",
          "experts/logos/ebay.png",
          "experts/logos/craigslist.png",
        ],
        pros: [
          "You can set your own price",
          "Can be done from the comfort of your home",
          "High value offers",
          "Exposure to large buyer pool creates competition",
        ],
        cons: [
          "Risk of exposure to scammers",
          "5% or less likelihood of an actual sale",
          "Can take a very long time to get an offer",
          "Large number of items competing with yours",
        ],
        bottomLine:
          "This is an easy option but your chances of selling are low.",
      },
      {
        title: "Online consignment",
        images: ["experts/logos/realReal.png"],
        pros: [
          "Easy - all you need to do is ship",
          "Mid-high value offers",
          "Low exposure to scammers",
          "Mid-high likelihood of selling",
        ],
        cons: [
          "No control over the selling price",
          "A 25%-45% fee is deducted from the final sale amount",
          "Additional discounts can be taken at your expense",
          "Finding a buyer can take weeks or even months",
        ],
        bottomLine:
          "This is an easy option with a good chance of selling, however the process is not quick and the final amount you receive can be low.",
      },
      {
        title: "Online jewelers",
        images: [
          "experts/logos/wpDiamonds.png",
          "experts/logos/circa.png",
          "experts/logos/abeMor.png",
        ],
        pros: [
          "Easy - all you need to do is ship",
          "High likelihood of selling",
          "Low exposure to scammers",
          "Speedy transaction - typically within several days",
        ],
        cons: [
          "You can’t set your own price",
          "Medium value offers",
          "Only one potential buyer - no competition",
        ],
        bottomLine:
          "This is an easy option and your chances of selling for a reasonable price are high.",
      },
      {
        title: "Pawn shops",
        images: [],
        pros: [
          "Often the fastest way to turn valuables into cash",
          "Likely to get an offer",
        ],
        cons: [
          "Requires legwork",
          "Can be risky and difficult to trust",
          "Pushback and/or bargaining tactics are to be expected",
          "Likely to give low offers",
          "Only one potential buyer - no competition",
        ],
        bottomLine:
          "This is your best fast cash option but not your best value option.",
      },
    ];
  }

  render() {
    return (
      <div className="where-to-sell">
        <div className="comparison margin-0-auto d-flex flex-col">
          <div className="comparison-header">
            <PageHeader
              label={{ title: "Resource", color: "#C7427C" }}
              title="Where to Sell Pre-owned Diamond Jewelry"
              diamondText="Comparative Analysis"
            />
            <PageIntro
              pic={{
                alt: "like-dislike icon",
                url: "experts/likeDislikeIcon.svg",
              }}
              text="Our comparative analysis includes all of the different types of platforms and venues you can sell your diamonds on to help you make the best, most accurate, choice for you."
            />
          </div>
          <div className="comparison-content">
            <div className="DT-title-row d-flex">
              <div className="header-container-PH"></div>
              <div className="title-box d-flex flex-col">
                <img
                  className="like-icon"
                  alt="like icon"
                  src={imageUrl("experts/prosIcon.svg")}
                />
                <Regular text={"Pros"} />
              </div>
              <div className="title-box d-flex flex-col">
                <img
                  className="like-icon"
                  alt="like icon"
                  src={imageUrl("experts/consIcon.svg")}
                />
                <Regular text={"Cons"} />
              </div>
              <div className="title-box d-flex flex-col bottom-line">
                <Regular
                  overrideCSS={{
                    color: "white",
                    marginTop: !this.isMobile ? "32px" : "",
                  }}
                  text={"Bottom line"}
                />
              </div>
            </div>
            {this.comparisonData().map((option) => {
              return <ProsConsBox key={option.title} option={option} />;
            })}
          </div>
          <LikeDislikeBanner
            question="Was this content helpful?"
            closingText="Thank you for your feedback!"
            eventsLabel="from Where To Sell page"
          />
        </div>
        <DIYSection
          eventsLabel={EVENTS_LABEL}
          data={["HOW_TO_PRICE"]}
          recomended={true}
        />
        <div className="cards-container">
          <ServicesSection
            pageName="Where To Sell"
            lastItem={this.props.LastItem}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ LastItem }) => {
  return {
    LastItem,
  };
};

export default connect(mapStateToProps)(WhereToSell);
